





































import Vue from "vue";
import axios from "axios";
import { env } from "@/env";
import Modal from "@/components/root/modal/Modal.vue";
import { ref, computed } from "@vue/composition-api";
import { ModalConfig } from "../root/modal";
import { getErrStatusCode } from "@/common/api/err.handler";
import { LoggedUser } from "@/common/models";
export default Vue.extend({
  components: {
    Modal,
  },
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "28rem",
      backdropDismiss: false,
    };

    const email = ref("");
    const password = ref("");

    //#region  error
    const errorCode = ref(0);
    const errorMsg = computed(() => {
      const code = errorCode.value;
      switch (true) {
        case code === 0:
          return "";
        case code === 401:
          return "email or password are incorrect";
        default:
          return "server error, please try again soon";
      }
    });
    //#endregion

    const onCancel = () => {
      emit("cancel");
    };

    function validateEmail(email: string) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    const isValidEmail = computed(
      () => email.value.trim().length > 0 && validateEmail(email.value)
    );

    const isValidPassword = computed(() => password.value.trim().length > 4);

    const isValidForm = computed(
      () => isValidEmail.value && isValidPassword.value
    );

    const disableBtn = computed(() => !isValidForm.value);

    const login = async () => {
      if (disableBtn.value) {
        return;
      }
      errorCode.value = 0;
      const e = await env();
      axios.defaults.baseURL = e.server;
      try {
        const res = await axios.post("/login", {
          email: email.value,
          password: password.value,
        });
        const token = res.data;
        axios.defaults.headers.authorization = token;
        localStorage.setItem(
          "user",
          JSON.stringify({
            email: email.value,
            authorization: token,
            name: email.value.split("@")[0],
            orgName: "?",
            showUI: true,
            auditLogConsent: true,
          } as LoggedUser)
        );

        emit("submit");
      } catch (e) {
        // @ts-ignore
        errorCode.value = getErrStatusCode(e);
      }
    };

    return {
      email,
      password,
      disableBtn,
      config,
      onCancel,
      login,
      errorMsg,
    };
  },
});
